module.exports = __webpack_public_path__ + "img/total_light.b821b2ac.svg";